export default "__VITE_ASSET__UGeW3WwT__"